import { render, staticRenderFns } from "./Teamwork.vue?vue&type=template&id=0513ebd9&scoped=true&lang=html&"
import script from "./Teamwork.vue?vue&type=script&lang=js&"
export * from "./Teamwork.vue?vue&type=script&lang=js&"
import style0 from "./Teamwork.vue?vue&type=style&index=0&id=0513ebd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513ebd9",
  null
  
)

export default component.exports